import React from 'react';

import { RecursiveMenu } from '@uncinc/react-drupal-core';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const FooterMenu = () => (
  <div className="FooterMenu">
    <Container>
      <RecursiveMenu menuId="footer" maxLevel={2} />
    </Container>
  </div>
);


export default FooterMenu;
